import { css } from 'aphrodite';
import * as React from 'react';
import { TicketPriority } from '../../../models/Support/SupportEnums';
import { Pill } from '../../../web/components-v2/Pill';
import { ticketTableStyles as ts } from './styles/ticketTableStyles';
import { PRIORITY_COLOR } from './supportTicketPresentation';

/**
 * A ticket's priority as the desks scan it. Everything up to High is a shared tinted `Pill`; Urgent
 * is a solid deep red, because it has to out-rank the red pill sitting on the row above it and two
 * tints of the same wash do not separate at a glance.
 *
 * Deliberately page-local rather than a tenth `THEME.colors.pill` entry: that map is the vocabulary
 * the contact-tag colour picker enumerates, so a colour added for this desk would show up there as a
 * pickable tag colour.
 */
export const TicketPriorityPill: React.FC<{ priority: TicketPriority }> = ({ priority }) =>
	priority === TicketPriority.Urgent ? (
		<span className={css(ts.urgentPriorityPill)}>{priority}</span>
	) : (
		<Pill variant='tag' color={PRIORITY_COLOR[priority] ?? 'blue'} size='small' label={priority} />
	);
